import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import { palette, zIndex, fontDefault } from '@mirinae/react-ui';

import TryFreeButton from '@mirinae/lessons/components/buttons/TryFreeButton1.0';
import GlobalContext from '@mirinae/lessons/modules/contexts/global';
import IconRocket from '@mirinae/lessons/assets/images/icon-rocket.svg';
import IconClose from '@mirinae/lessons/assets/images/icon-x.svg';
import { lessonsPaths, explorerPaths, membersPaths, authPaths} from '@mirinae/shared/defines/paths';

const Popup = styled.div`
    position: fixed;
    font-family: ${fontDefault};
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: ${zIndex.cookieBanner + 10};
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.3);
`;
const PopupInner = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 350px;
    padding: 40px;
    border-radius: 10px;
    background-color: ${palette.primary.white};
    text-align: center;
    a {
        width: 100%;
    }
    svg {
        margin-bottom: 15px;
    }
    @media only screen and (max-width: 390px) {
        width: 100%;
        margin: 0 20px;
        padding: 40px 20px;
    }
`;
const Title = styled.h4`
    margin-bottom: 15px;
    color: ${palette.gray[1]};
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
`;
const Text = styled.div`
    margin-bottom: 30px;
    color: #555;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
`;
const LearnMoreLink = styled.a`
    display: block;
    width: 100%;
    height: 25px;
    margin-top: 30px;
    font-size: 14px;
    font-weight: 600;
    background: linear-gradient(to right, #3499FF 0%, #3A3985 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;
const Button = styled.div`
    position: absolute;
    width: 24px;
    height: 24px;
    cursor: pointer;

    :hover svg path {
        stroke: ${palette.gray[2]};
    }
    :disabled svg path {
        stroke: ${palette.gray[6]};
    }
    &.btn-cancel {
        right: 13px;
        top: 13px;
    }
`;

const CloseButton = (props) => (
    <Button {...props}>
        <img src={IconClose} alt="Close" />
    </Button>
);

const UpgradeProPopup = ({ onClose }) => {
    const global = useContext(GlobalContext);

    return (
        <Popup>
            <PopupInner>
                <img src={IconRocket} alt="Rocket icon" />
                <Title>Upgrade to Pro</Title>
                <Text>Upgrade to Mirinae Pro to get full access to all the Mirinae Pro features!</Text>
                <TryFreeButton />
                { global.isProEnabledVersion && <LearnMoreLink href={membersPaths.pro}>Learn more</LearnMoreLink> }
                <CloseButton className="btn-cancel" onClick={onClose} />
            </PopupInner>
        </Popup>
    );
};

export default UpgradeProPopup;